module.exports = __webpack_public_path__ + "img/ddfa5ff6addab2a7adf88f52ddf999e2.png";